import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-peer-signup-thank-you',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './peer-signup-thank-you.component.html',
  styleUrls: ['./peer-signup-thank-you.component.scss']
})
export class PeerSignupThankYouComponent {
  constructor(private router: Router) {}

  navigateHome(): void {
    this.router.navigate(['/partner-signin']);
  }
}
